export const featureImages = {
    combineInvoice: '/assets/jpg/feature1.jpg',
    holidayCompensation: '/assets/jpg/feature2.jpg',
    expressPayment: '/assets/jpg/feature3.jpg',
    multipleCurrencies: '/assets/jpg/feature4.jpg',
    agreementOffers: '/assets/jpg/feature5.jpg',
    preliminaryInvoice: '/assets/jpg/feature6.jpg',
    timeReports: '/assets/jpg/feature7.jpg',
    vatRate: '/assets/jpg/feature8.jpg',
    foreignBank: '/assets/jpg/feature9.jpg',
    rutRot: '/assets/jpg/feature10.jpg',
    footer: '/assets/jpg/featurefooter.jpg',
    personalizelogo: '/assets/jpg/personalizelogo.jpg',
};